import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { styled, StyleSheet } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import RenderLoading from '@rexlabs/render-loading';
var defaultStyles = StyleSheet({
  container: {
    width: '100%'
  },
  wrapList: {
    width: '100%'
  },
  wrapItem: {
    width: '100%'
  },
  wrapEmpty: {
    width: '100%'
  },
  separator: {
    width: '100%',
    height: '1px',
    backgroundColor: 'gray'
  },
  renderLoading: {}
});
var List = (_dec = styled(defaultStyles), _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(List, _PureComponent);

  function List() {
    _classCallCheck(this, List);

    return _possibleConstructorReturn(this, _getPrototypeOf(List).apply(this, arguments));
  }

  _createClass(List, [{
    key: "renderList",
    value: function renderList() {
      var _this$props = this.props,
          s = _this$props.styles,
          LoadMore = _this$props.LoadMore,
          Header = _this$props.Header;
      return React.createElement(Box, s('wrapList'), Header && React.createElement(Header, null), this.renderListItems(), LoadMore && React.createElement(LoadMore, null));
    }
  }, {
    key: "renderListItems",
    value: function renderListItems() {
      var _this$props2 = this.props,
          s = _this$props2.styles,
          items = _this$props2.items,
          renderItem = _this$props2.renderItem,
          getKey = _this$props2.getKey;
      return _mapInstanceProperty(items).call(items, function (data, index) {
        return React.createElement(Box, _extends({}, s('wrapItem'), {
          key: getKey(data, index)
        }), renderItem(data, index), index < items.length - 1 && React.createElement(Box, s('separator')));
      });
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var _this$props3 = this.props,
          s = _this$props3.styles,
          EmptyView = _this$props3.EmptyView,
          Header = _this$props3.Header,
          alwaysRenderHeader = _this$props3.alwaysRenderHeader;
      return React.createElement(Box, s('wrapEmpty'), Header && alwaysRenderHeader && React.createElement(Header, null), EmptyView ? React.createElement(EmptyView, {
        key: "EmptyView"
      }) : React.createElement(Box, {
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        key: "EmptyDefault"
      }, "No results found!"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          s = _this$props4.styles,
          isLoading = _this$props4.isLoading,
          loadErrors = _this$props4.loadErrors,
          LoadingView = _this$props4.LoadingView,
          ErrorView = _this$props4.ErrorView,
          items = _this$props4.items,
          alwaysRenderChildren = _this$props4.alwaysRenderChildren;
      return React.createElement("div", s('container'), React.createElement(RenderLoading, _extends({}, s('renderLoading'), {
        isLoading: isLoading,
        loadErrors: loadErrors,
        LoadingView: LoadingView,
        ErrorView: ErrorView,
        alwaysRenderChildren: alwaysRenderChildren
      }), items.length ? this.renderList() : this.renderEmpty()));
    }
  }]);

  return List;
}(PureComponent), _defineProperty(_class2, "propTypes", {
  Header: PropTypes.elementType,
  renderItem: PropTypes.func.isRequired,
  items: PropTypes.array,
  EmptyView: PropTypes.elementType,
  LoadMore: PropTypes.elementType,
  isLoading: PropTypes.bool.isRequired,
  loadErrors: PropTypes.array,
  LoadingView: PropTypes.func,
  ErrorView: PropTypes.func,
  getKey: PropTypes.func,
  alwaysRenderHeader: PropTypes.bool,
  alwaysRenderChildren: PropTypes.bool
}), _defineProperty(_class2, "defaultProps", {
  items: [],
  getKey: function getKey(_, index) {
    return index;
  },
  isLoading: false,
  alwaysRenderHeader: false,
  alwaysRenderChildren: true
}), _temp)) || _class) || _class);
export default List;